// GENERATED from games/packages/vertical-core/config.js. Run npm run build:client in games.
export const DEFAULT_CONFIG = Object.freeze({
  day_speed: 44, night_speed: 66, mars_speed: 90,
  day_gap_min: 100, day_gap_max: 120, night_gap_min: 112, night_gap_max: 130,
  mars_gap_min: 124, mars_gap_max: 140, night_score: 250, mars_score: 750,
});
export function validateConfig(value = DEFAULT_CONFIG) {
  if (!value || typeof value !== 'object' || Array.isArray(value)) throw new TypeError('Invalid configuration');
  if (Object.keys(value).some(key => !Object.hasOwn(DEFAULT_CONFIG, key))) throw new TypeError('Unknown configuration field');
  const config = { ...DEFAULT_CONFIG, ...value };
  for (const [key, number] of Object.entries(config)) {
    const [low, high] = key.endsWith('_speed') ? [10, 160] : key.includes('_gap_') ? [60, 140] : [10, 100000];
    if (!Number.isInteger(number) || number < low || number > high) throw new TypeError('Invalid ' + key);
  }
  for (const world of ['day', 'night', 'mars']) if (config[world + '_gap_min'] > config[world + '_gap_max']) throw new TypeError('Invalid gap range');
  if (config.night_score >= config.mars_score) throw new TypeError('Marte debe empezar después de Noche');
  if (config.day_speed > config.night_speed || config.night_speed > config.mars_speed) throw new TypeError('La velocidad no puede disminuir entre mundos');
  return config;
}
